import { faker } from '@faker-js/faker';
import { sample } from 'lodash';

// ----------------------------------------------------------------------

const zakazky = [...Array(24)].map((_, index) => ({
  id: faker.datatype.uuid(),
  number: faker.datatype.number(),
  clientName: faker.name.fullName(),
  clientMail: faker.internet.email(),
  status: sample(['hrubá stavba', 'holodom', 'na kľúč', 'ukončené']),
  place: sample(['Žilina', 'Košice', 'Stropkov', 'Lipníky', 'Leopoldov']),
  lat: faker.address.latitude(),
  lng: faker.address.longitude(),
  dateEnd: faker.date.between('2020-01-01T00:00:00.000Z', '2030-01-01T00:00:00.000Z'),
  partiaId: 1,
  zakladovaDoskaDate: faker.date.between('2020-01-01T00:00:00.000Z', '2030-01-01T00:00:00.000Z'),
  hrubovaStavbaDate: faker.date.between('2020-01-01T00:00:00.000Z', '2030-01-01T00:00:00.000Z'),
  holodomDate: faker.date.between('2020-01-01T00:00:00.000Z', '2030-01-01T00:00:00.000Z'),
  domNaKlucDate: faker.date.between('2020-01-01T00:00:00.000Z', '2030-01-01T00:00:00.000Z'),
  komin: '',
  skridla: '',
  hydroizolacia: '',
  rost: '',
  povala: '',
  zateplenie: '',
  okna: '',
  dvere: '',
  bojler: '',
  vykurovanie: '',
  rekuperacia: '',
  pristup: '',
  poznamky: '',
  zaluzie: '',
  zaluzieFazy: '',
  zaluzieSposob: '',
  zaluzieMnozstvo: '',
  zaluzieObjednanieDate: faker.date.between('2020-01-01T00:00:00.000Z', '2030-01-01T00:00:00.000Z'),
  zaluzieZameranieDate: faker.date.between('2020-01-01T00:00:00.000Z', '2030-01-01T00:00:00.000Z'),
  zaluzieMontazDate: faker.date.between('2020-01-01T00:00:00.000Z', '2030-01-01T00:00:00.000Z'),
  zaluziePoznamky: '',
  fotovoltika: '',
  fotoVoltikaTyp: '',
  fotovoltikaSuma: '',
  fotovoltikaHrubaStavbaDate: faker.date.between('2020-01-01T00:00:00.000Z', '2030-01-01T00:00:00.000Z'),
  fotovoltikaKontaktnaOsobaHrubaStavba: '',
  fotovoltikaHolodomDate: faker.date.between('2020-01-01T00:00:00.000Z', '2030-01-01T00:00:00.000Z'),
  fotovoltikaKontaktnaOsoba: '',
}));

export default zakazky;
